/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlResolutionRequestOrderByMethods = {
    Created: 'created',
    Status: 'status'
} as const;
export type ControlResolutionRequestOrderByMethods = typeof ControlResolutionRequestOrderByMethods[keyof typeof ControlResolutionRequestOrderByMethods];


export function ControlResolutionRequestOrderByMethodsFromJSON(json: any): ControlResolutionRequestOrderByMethods {
    return ControlResolutionRequestOrderByMethodsFromJSONTyped(json, false);
}

export function ControlResolutionRequestOrderByMethodsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResolutionRequestOrderByMethods {
    return json as ControlResolutionRequestOrderByMethods;
}

export function ControlResolutionRequestOrderByMethodsToJSON(value?: ControlResolutionRequestOrderByMethods | null): any {
    return value as any;
}

